import {GET_DATA_PLANHANDLESTEP_PLANHANDLE, SET_DATA_PLANHANDLESTEP_PLANHANDLE, GET_DATA_HISTORY, GET_DATA_STATUS_ACTION_HISTORY} from '../actions/actionTypes'

import {RequertPlanHandleStepPlanHandleFaileAction, GetDataPlanHandleStepPlanHandleSuccessAction, SetDataPlanHandleStepSuccessAction,
     GetDataHistorySuccessAction, GetDataHistoryFaileAction, GetStatusActionHistorySuccess, GetStatusActionHistoryFailed } from '../actions'

import { put, takeLatest} from 'redux-saga/effects'
import { Api } from './api'

function* GetDataPlanHandleStep(action){
    try{
        const DataPlanHandleStep = yield Api.GetDataPlanHandleStepFromApi(action.id, action.step);
        yield put(GetDataPlanHandleStepPlanHandleSuccessAction(DataPlanHandleStep))
    }catch(error){
        yield put(RequertPlanHandleStepPlanHandleFaileAction(error))
    }
}
export function* watchGetDataPlanHandleStep(){
    yield takeLatest(GET_DATA_PLANHANDLESTEP_PLANHANDLE, GetDataPlanHandleStep)
}

function* SetDataPlanHandleStep(action){
    try{
        const Data = yield Api.SetDataPlanHandleStepFromApi(action.DataPlanHandleStep);
        yield put(SetDataPlanHandleStepSuccessAction(Data))
        
    }catch(error){
        console.log("error",error)
        yield put(RequertPlanHandleStepPlanHandleFaileAction(error))
    }
}

export function* watchSetDataPlanHandleStep(){
    yield takeLatest(SET_DATA_PLANHANDLESTEP_PLANHANDLE, SetDataPlanHandleStep)
}

function* GetDataHistory(action){
    //console.log("planIDDebug", action);
    try{
        const Data = yield Api.GetLogsByPlanID(action.planID);
        yield put(GetDataHistorySuccessAction(Data))
        
    }catch(error){
        console.log("error",error)
        yield put(GetDataHistoryFaileAction(error))
    }
}
export function* watchGetDataHistory(){
    yield takeLatest(GET_DATA_HISTORY, GetDataHistory)
}

function* GetStatusActionHistory(action){
    try{
        const Data = yield Api.GetStatusActionHistoryFromApi(action.planID);
        yield put(GetStatusActionHistorySuccess(Data))
        
    }catch(error){
        console.log("error",error)
        yield put(GetStatusActionHistoryFailed(error))
    }
}
export function* watchGetStatusActionHistory(){
    yield takeLatest(GET_DATA_STATUS_ACTION_HISTORY, GetStatusActionHistory)
}